import { useMutation } from '@tanstack/react-query'
import { NotificationService } from '@/modules/utilities/notification/services/NotificationService.ts'

const useActions = () => {
  const { mutate: handlerSelect } = useMutation({
    mutationKey: ['handlerSelectNotification'],
    mutationFn: (id: string) => {
      return NotificationService.read(id)
    }
  })

  return {
    handlerSelect
  }
}

export default useActions
